import { ApplicationHelpType, UserSettingTypesEnum } from '../../utilities/Constants';
import React, { useEffect } from 'react';
import { showErrorToast, showSuccessToast } from '../../shared/ToastUtils';

import CheckmateSelect from '../shared/CheckmateSelect';
import { Help } from '../shared/Help';
import { IMultiSelectOption } from '../../interfaces/ILookup';
import { IUserSettingModel } from '../../interfaces/ITask';
import { useGetUserSetting } from './useGetUserSetting';
import { useUpdateUserSettingMutation } from './useUpdateUserSettingMutation';

interface ISelectDropdownUserSettingProps {
    helpText?: string;
    helpTitle?: string;
    label: string;
    options: IMultiSelectOption[];
    selectedValue?: IMultiSelectOption;
    settingType: UserSettingTypesEnum;
}

export function SelectDropdownUserSetting(props: ISelectDropdownUserSettingProps) {
    const [validation, setValidation] = React.useState<string | undefined>(undefined);

    const userSetting = useGetUserSetting(props.settingType);
    const updateUserSettingMutation = useUpdateUserSettingMutation((errorMessage) => {
        setValidation(errorMessage);
    });

    const [localUserSetting, setLocalUserSetting] = React.useState<IUserSettingModel | undefined>(
        undefined
    );

    const handleSettingChange = (selectedOption: IMultiSelectOption) => {
        if (selectedOption?.value === localUserSetting?.settingsJson) {
            return;
        }

        updateUserSettingMutation
            .mutateAsync({
                guid: localUserSetting?.guid,
                typeId: props.settingType,
                settingsJson: selectedOption?.value,
            } as IUserSettingModel)
            .then(() => {
                showSuccessToast(`${props.label} updated!`);
                userSetting.refetch();
            })
            .catch((error) => {
                showErrorToast(error.message ?? 'Failed to update user setting');
            });
    };

    React.useEffect(() => {
        setLocalUserSetting(userSetting.data);
    }, [userSetting.data]);

    return (
        <>
            <div className="row">
                <div className="col-12 col-sm-6 col-lg-4 col-xl-3" style={{ whiteSpace: 'nowrap' }}>
                    <label>{props.label}</label>
                    {props.helpText && props.helpTitle && (
                        <Help
                            type={ApplicationHelpType.Info}
                            helpText={props.helpText}
                            title={props.helpTitle ?? ''}
                        />
                    )}
                </div>
                <div className="col-12 col-sm-6 col-lg-5 col-xl-3">
                    <CheckmateSelect
                        onChange={handleSettingChange}
                        options={props.options}
                        value={props.options.find(
                            (opt) => opt.value === localUserSetting?.settingsJson
                        )}
                        isLoading={updateUserSettingMutation.isLoading || userSetting.isFetching}
                        notClearable
                        isDisabled={userSetting.isFetching}
                    />
                    {validation && (
                        <div className="text-danger mt-1" style={{ fontSize: '0.8rem' }}>
                            {validation}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
